import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useEffect } from 'react';

const TermsOfService = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#2C2E2D] text-[#D9D9D9]">
      <div className="container mx-auto py-16 px-4 max-w-4xl">
        <h1 className="text-3xl font-bold mb-8 text-[#CCF751]">Terms of Service</h1>
        
        <div className="bg-yellow-900/30 border border-yellow-600/50 text-yellow-200 p-4 rounded-md mb-8">
          <p className="font-medium">⚠️ DISCLAIMER: DRAFT DOCUMENT</p>
          <p className="text-sm mt-2">
            This is a draft Terms of Service document for demonstration purposes only. 
            This document has not been reviewed by legal professionals and is not suitable for actual use.
            Before launching your service publicly, please have this document reviewed and customized by a legal professional
            familiar with internet law in your jurisdiction and EU regulations including GDPR.
          </p>
        </div>
        
        <div className="space-y-8">
          <section>
            <h2 className="text-xl font-semibold mb-4">1. Introduction</h2>
            <p className="mb-4">
              Welcome to JobPin. These Terms of Service govern your use of our website and services.
              By accessing or using JobPin, you agree to be bound by these Terms.
            </p>
            <p>
              If you disagree with any part of these terms, you may not access our service.
            </p>
          </section>
          
          <section>
            <h2 className="text-xl font-semibold mb-4">2. Use of Service</h2>
            <p className="mb-4">
              JobPin provides tools to help you track and manage job applications. You are responsible for maintaining 
              the confidentiality of your account and password and for restricting access to your computer.
            </p>
            <p>
              You agree to accept responsibility for all activities that occur under your account.
            </p>
          </section>
          
          <section>
            <h2 className="text-xl font-semibold mb-4">3. User Data</h2>
            <p className="mb-4">
              JobPin stores information about job applications that you provide. You maintain ownership of your data, 
              and we will not share your personal information with third parties without your consent.
            </p>
            <p>
              For more details on how we handle your data, please refer to our Privacy Policy.
            </p>
          </section>
          
          <section>
            <h2 className="text-xl font-semibold mb-4">4. Prohibited Uses</h2>
            <p className="mb-4">
              You may not use JobPin for any illegal purposes or to conduct activities that could damage, disable, 
              or impair our services. You may not attempt to gain unauthorized access to any portion of the service.
            </p>
          </section>
          
          <section>
            <h2 className="text-xl font-semibold mb-4">5. Intellectual Property</h2>
            <p className="mb-4">
              The service and its original content, features, and functionality are owned by JobPin and are 
              protected by international copyright, trademark, and other intellectual property laws.
            </p>
          </section>
          
          <section>
            <h2 className="text-xl font-semibold mb-4">6. Termination</h2>
            <p className="mb-4">
              We may terminate or suspend your account and access to our service immediately, without prior 
              notice or liability, for any reason, including without limitation if you breach the Terms.
            </p>
            <p>
              Upon termination, your right to use the service will immediately cease.
            </p>
          </section>
          
          <section>
            <h2 className="text-xl font-semibold mb-4">7. Limitation of Liability</h2>
            <p className="mb-4">
              In no event shall JobPin be liable for any indirect, incidental, special, consequential or 
              punitive damages, including without limitation, loss of profits, data, use, goodwill, or other 
              intangible losses, resulting from your access to or use of or inability to access or use the service.
            </p>
          </section>
          
          <section>
            <h2 className="text-xl font-semibold mb-4">8. Changes to Terms</h2>
            <p className="mb-4">
              We reserve the right to modify or replace these Terms at any time. By continuing to access 
              or use our service after those revisions become effective, you agree to be bound by the revised terms.
            </p>
          </section>
          
          <section>
            <h2 className="text-xl font-semibold mb-4">9. Contact Us</h2>
            <p className="mb-4">
              If you have any questions about these Terms, please contact us at support@jobpin.example.com.
            </p>
          </section>
        </div>
        
        <div className="mt-12 text-center">
          <Link to="/">
            <Button className="bg-[#CCF751] text-[#2C2E2D] hover:bg-[#CCF751]/90">
              Back to Home
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService; 